module.exports = __webpack_public_path__ + "img/collection-from.58992ec6.svg";